import {
  getStatusName as baseGetStatusName,
  getStatusObjectByName as baseGetStatusObjectByName,
} from "asokoinsight-helpers-business-logic/src/dff-helpers";

type Entity =
  | "investee"
  | "investor"
  | "intermediary"
  | "match"
  | "seekers"
  | string;

const buildFallbackStatus = (state?: string) => {
  if (!state) return undefined;
  return {
    name: state,
    value: state,
    label: `TO DO ${state}`,
    color: "pending",
    chartColor: "#c0c0c0",
  };
};

export function getStatusName(state: string, entity?: Entity) {
  return baseGetStatusName(state, entity) || buildFallbackStatus(state);
}

export function getStatusObjectByName(name: string, entity?: Entity) {
  return baseGetStatusObjectByName(name, entity) || buildFallbackStatus(name);
}
